export default "__VITE_ASSET__9tJGHNUP__"